import { z } from 'zod';

export const DatiqActionSchema = z.object({
    name: z.string(), // ngrx action this should fire
    payload: z.unknown(), // payload for the ngrx action
});

export type DatiqAction = z.infer<typeof DatiqActionSchema>;

// TODO: use schema to generate this but figure out why it's being grumpy
export interface IDatiqAction {
    name: string;
    payload?: unknown;
}
